import { get, post } from "@services/apiService.js";
export default {
  getGoogleMap() {
    return get(`/v4/google-api-manager/v1/google-map/key`)
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  setGoogleMapKey(gmapKey) {
    return post(`/v4/google-api-manager/v1/google-map/key`,{gmapKey: gmapKey})
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
}